<button [type]="type" [attr.form]="form || null" class="app-btn" [ngClass]="variantClass" [disabled]="disabled">
  <ng-content></ng-content>
</button>
